import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_cookieuniversalnuxt_4098bdcf from 'nuxt_plugin_cookieuniversalnuxt_4098bdcf' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_sentryserver_23a8f4eb from 'nuxt_plugin_sentryserver_23a8f4eb' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_8420f93a from 'nuxt_plugin_sentryclient_8420f93a' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_router_2f3fc468 from 'nuxt_plugin_router_2f3fc468' // Source: ./router.js (mode: 'all')
import nuxt_plugin_axios_7fd64c27 from 'nuxt_plugin_axios_7fd64c27' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cms_a7c7fab4 from 'nuxt_plugin_cms_a7c7fab4' // Source: ../node_modules/@i22/frontend-cms-utils/plugins/cms (mode: 'all')
import nuxt_plugin_axios_150eaa93 from 'nuxt_plugin_axios_150eaa93' // Source: ../node_modules/@i22/frontend-cms-utils/plugins/axios (mode: 'all')
import nuxt_plugin_vuexorm_560f3312 from 'nuxt_plugin_vuexorm_560f3312' // Source: ../node_modules/@i22/frontend-cms-utils/plugins/vuex-orm (mode: 'all')
import nuxt_plugin_consolalevel_24eb88b2 from 'nuxt_plugin_consolalevel_24eb88b2' // Source: ../node_modules/@i22/frontend-cms-utils/plugins/consola-level (mode: 'all')
import nuxt_plugin_i18n_ff1cda5e from 'nuxt_plugin_i18n_ff1cda5e' // Source: ../node_modules/beisheim/plugins/i18n (mode: 'all')
import nuxt_plugin_localstorage_638a6ac6 from 'nuxt_plugin_localstorage_638a6ac6' // Source: ../node_modules/beisheim/plugins/local-storage (mode: 'client')
import nuxt_plugin_picturefill_5773eb6e from 'nuxt_plugin_picturefill_5773eb6e' // Source: ../node_modules/beisheim/plugins/picturefill (mode: 'client')
import nuxt_plugin_swiper_3f59606b from 'nuxt_plugin_swiper_3f59606b' // Source: ../node_modules/beisheim/plugins/swiper (mode: 'client')
import nuxt_plugin_scrollspy_21ec712f from 'nuxt_plugin_scrollspy_21ec712f' // Source: ../node_modules/beisheim/plugins/scroll-spy (mode: 'client')
import nuxt_plugin_sticky_3f2ee9dc from 'nuxt_plugin_sticky_3f2ee9dc' // Source: ../node_modules/beisheim/plugins/sticky (mode: 'client')
import nuxt_plugin_clickoutside_4b09286c from 'nuxt_plugin_clickoutside_4b09286c' // Source: ../node_modules/beisheim/plugins/click-outside.js (mode: 'client')
import nuxt_plugin_vuetouchevents_6a319dd6 from 'nuxt_plugin_vuetouchevents_6a319dd6' // Source: ../node_modules/beisheim/plugins/vue-touch-events.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"layout","mode":"out-in","beforeEnter":function _beforeEnter () {
      const el = document.querySelector('.transition-rect')
      if (el) {
        el.classList.add('transition-rect--enter')
      }
      window.scrollTo(0, 0)
    },"afterEnter":function _afterEnter () {
      const el = document.querySelector('.transition-rect')
      if (el) {
        el.classList.remove(
          'transition-rect--enter',
          'transition-rect--sport',
          'transition-rect--kultur',
          'transition-rect--gesundheit',
          'transition-rect--bildung'
        )
      }
    },"beforeLeave":function _beforeLeave () {
      const el = document.querySelector('.transition-rect')
      const colorFocuses = ['bildung', 'sport', 'gesundheit', 'kultur']
      const color = colorFocuses[Math.floor(Math.random() * colorFocuses.length)]
      const colorClass = `transition-rect--${color}`
      if (el) {
        el.classList.add('transition-rect--leave', colorClass)
      }
    },"afterLeave":function _afterLeave () {
      const el = document.querySelector('.transition-rect')
      if (el) {
        el.classList.remove('transition-rect--leave')
      }
    },"appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Beisheim Stiftung","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Frontend of Stiftung"},{"hid":"og:description","name":"og:description","content":"Frontend of Stiftung"},{"hid":"og:title","name":"og:title","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_cookieuniversalnuxt_4098bdcf === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_4098bdcf(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_23a8f4eb === 'function') {
    await nuxt_plugin_sentryserver_23a8f4eb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_8420f93a === 'function') {
    await nuxt_plugin_sentryclient_8420f93a(app.context, inject)
  }

  if (typeof nuxt_plugin_router_2f3fc468 === 'function') {
    await nuxt_plugin_router_2f3fc468(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7fd64c27 === 'function') {
    await nuxt_plugin_axios_7fd64c27(app.context, inject)
  }

  if (typeof nuxt_plugin_cms_a7c7fab4 === 'function') {
    await nuxt_plugin_cms_a7c7fab4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_150eaa93 === 'function') {
    await nuxt_plugin_axios_150eaa93(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexorm_560f3312 === 'function') {
    await nuxt_plugin_vuexorm_560f3312(app.context, inject)
  }

  if (typeof nuxt_plugin_consolalevel_24eb88b2 === 'function') {
    await nuxt_plugin_consolalevel_24eb88b2(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_ff1cda5e === 'function') {
    await nuxt_plugin_i18n_ff1cda5e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localstorage_638a6ac6 === 'function') {
    await nuxt_plugin_localstorage_638a6ac6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_picturefill_5773eb6e === 'function') {
    await nuxt_plugin_picturefill_5773eb6e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_3f59606b === 'function') {
    await nuxt_plugin_swiper_3f59606b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollspy_21ec712f === 'function') {
    await nuxt_plugin_scrollspy_21ec712f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sticky_3f2ee9dc === 'function') {
    await nuxt_plugin_sticky_3f2ee9dc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickoutside_4b09286c === 'function') {
    await nuxt_plugin_clickoutside_4b09286c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetouchevents_6a319dd6 === 'function') {
    await nuxt_plugin_vuetouchevents_6a319dd6(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
